import { PlusOutlined } from "@ant-design/icons";
import { Divider, Modal, Row, Space, Col, Button, Flex, Form } from "antd";
import { Formik } from "formik";
import { Input, InputGroup, InputNumber, RadioGroup, Select } from "components/form";
import { useTranslation } from "react-i18next";
import { DatePicker } from "components/form";
import { formatDate } from "utils/formatter";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { CardContainer } from "components/elements";
import EmployeeInfoFamilyTable from "components/table/EmployeeInfoFamilyTable";
import schema, {
  initialValues as INITIAL_VAUES,
} from "../schemas/employeeInfoFamilySchema";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";

function EmployeeInfoFamily({
  isLoading = false,
  initialValues = {},
  familyList = [],
  pagination = {},
  isModalOpen = false,
  dataDetail = {},
  onSubmit = () => { },
  onCancel = () => { },
  onChange = () => { },
  onCreate = () => { },
  onEdit = () => { },
  onDelete = () => { },
  setIsModalOpen = () => { },
  relationshipOptions = [],
  occupationOptions = [],
}) {
  const { roles } = useSelector((state) => state.company);
  const { t } = useTranslation();
  // const relationshipOptions = useSelector((state) => state.options.relationshipOptions)
  return (

    <Space style={{ width: "100%" }} size={16} direction="vertical">
      <Modal
        destroyOnClose
        title={
          initialValues?.id ? t('common.edit') : t('common.create')
        }
        open={isModalOpen}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        footer={null}
        width={"30%"}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VAUES, ...initialValues, }}
          onSubmit={onSubmit}
          validationSchema={schema}
        >
          {({ values = {}, submitForm, setFieldValue, isValid, dirty }) => {

            return (
              <Form onFinish={submitForm}>
                {/* <Divider /> */}
                <Row gutter={[0, 20]}>
                  <Col span={24}>
                    <Input
                      required={true}
                      name="fullName"
                      label={t('employee.name-surname')}
                      placeholder={t('fill-in-name-surname')}
                      size="large"
                      onKeyDown={(e) => {
                        const isCharacterKey = /^[a-zA-Zก-๙\s]+$/.test(e.key);
                        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter", " "];

                        if (!isCharacterKey && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>

                  <Col span={24}>
                    <Select
                      required={true}
                      name="relationship"
                      label={t('relationship')}
                      placeholder={t('please-select-relationship')}
                      size="large"
                      options={relationshipOptions}
                    />
                  </Col>

                  <Col span={24}>
                    <DatePicker
                      name="dateOfBirth"
                      label={t('date-of-birth')}
                      placeholder={t('dd-mm-yyyy')}
                      size="large"
                      onChange={(e) => {
                        console.log("ee", e);
                        const date2 = dayjs();

                        let years = date2.diff(e, 'year');
                        setFieldValue('age', years)

                      }}
                      format={formatDate()}
                    />
                  </Col>

                  <Col span={24}>
                    <Select
                      name="career"
                      label={t('employee.occupation')}
                      placeholder={t('please-select-occupation')}
                      size="large"
                      options={occupationOptions}
                    />
                  </Col>

                  <Col span={24}>
                    <Input
                      name="mobileNumber"
                      label={t('mobile-no-0')}
                      placeholder={t('employee.mobile-no')}
                      size="large"
                    />

                  </Col>
                </Row>
                <Row justify="end" style={{ paddingTop: "20px" }}>
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="cancelBtn"
                      type="default"
                      onClick={() => {
                        onCancel();
                      }}
                      style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "40px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button htmlType="submit"
                      type="primary"
                      style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "40px", backgroundColor: !isValid || !dirty ? "" : "var(--button-color)" }}
                      disabled={!isValid || !dirty}
                    >
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Form>
            );
          }}
        </Formik>

      </Modal>

      {
        roles.includes("CREATE_EMPLOYEE|EMPLOYEE_INFO|FAMILY") && <Row justify="end">
          <Button onClick={(e) => {
            onCreate();
          }}
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
            type="primary"
          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              {t("common.create")}
            </Flex>
          </Button>
        </Row>
      }

      {/* <CardContainer width="100%" height="fit-content" > */}
      <EmployeeInfoFamilyTable
        isLoading={isLoading}
        dataSource={familyList}
        pagination={pagination}
        onEdit={onEdit}
        onChange={onChange}
        onDelete={onDelete}
      />
      {/* </CardContainer> */}
    </Space>
  );
}

export default EmployeeInfoFamily;